module.exports = __webpack_public_path__ + "static/img/product11.431e6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product11.png
// module id = n4Dz
// module chunks = 1